<ft-sheet-tabs state-array="sheetTabs"><div class="sheet-tabs"><ul></ul></div></ft-sheet-tabs>

<section class="ft-section invitation-intro-section">
  <div class="ft-container">
    @if (model().shareImagePreviewTemplate) {
      <div class="ft-section-image">
        <ft-iframe-content-ng class="iframe-container" [hasWrapper]="true"
                              [content]="model().shareImagePreviewTemplate" />
      </div>
    }
    <div class="ft-row">
      <div class="ft-col-60">
        <div class="ft-section-header mb-7">
          <div class="ft-heading ft-text-plus-3">{{ 'flipto.account.InvitationTitle' | translate }}</div>
          <p>{{ 'flipto.account.InvitationSubtitle' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="ft-row">
      <div class="ft-col-50">
        <p class="ft-heading ft-emphasis">
          Invite audiences to join {{ data().contest?.name }}
        </p>
        <p class="pb-5">
          Click a button below to share an invitation to your preferred social channel. Alternatively, you can feature one of your guest stories in your post—just go to Submissions, open a curated story and hit Broadcast.
        </p>
        <div class="share-links" [hidden]="!data().contest?.slug">
          <a class="facebook" (click)="shareInvitation(model().networks.fb)">Facebook</a>
          <a class="twitter" (click)="shareInvitation(model().networks.tw)">Twitter</a>
          <a class="linkedin" (click)="shareInvitation(model().networks.li)">LinkedIn</a>
        </div>
      </div>
      <div class="ft-col-50">
        <p class="ft-heading ft-emphasis">
          Display a permalink for your invitation page
        </p>
        <p class="pb-1">
          Use this URL if you want to display a permanent link on your website or emails. This link will always route to the invitation page for the current, active campaign.
        </p>
        <a class="contest-invitation-link underline pb-3" [href]="model().invitationUrl + '/guest-storytellers'" target="_blank">
          <span class="icon">
            <img src="/dist/v2-hybrid/v1-assets/img/icon-link-green.svg" />
          </span>
          {{ model().invitationUrl + '/guest-storytellers' }}
        </a>
        <span class="muted-text">You can append your own tracking parameters to the URL. Reach out and we'd be happy to give you guidance.</span>
      </div>
    </div>
    <div class="ft-row">
      <ft-short-url-list [themeName]="data().contest?.theme"
        [companyCode]="data().contest?.companyCode"
        [propertyUuid]="data().contest?.propertyUUID"
        [propertySlug]="data().contest?.propertySlug"
        [subdomains]="data().contest?.subdomains" />
    </div>
  </div>
</section>

<section class="ft-section ft-config-section invitation-details-section">
  <div class="ft-container">

    <div class="ft-section-header">
      <div class="ft-heading ft-text-plus-2">{{ 'flipto.account.CustomizeYourInvitationPage' | translate }}</div>
      <p>{{ 'flipto.account.CustomizeYourInvitationPageDescription' | translate }}</p>
    </div>

    <div class="preview-options">
      <ft-language-selector-ng [languages]="data().contest?.languages?.item" [selectedLanguage]="model().language"
                               (selectedLanguageChange)="model().language = $event" />
      @if (data().contest?.subdomains?.length > 0) {
        <a class="launch-preview" target="_blank"
           [class.disabled]="!data().contest?.slug"
           [ftDisabled]="!data().contest?.slug"
           [href]="data().contest?.subdomains | cnameUrl:3:data().contest?.propertySlug:{ contest: data().contest?.slug, lang: model().language?.code }">
          <span>{{ 'flipto.account.LivePreview' | translate }} <i class="ft-icn-external-link"></i></span>
        </a>
      }
    </div>

    <!--INVITEE GREETING PANEL-->
    <div class="ft-panel" ft-modal-fields-editor (click)="editInviteeGreeting()">
      <div class="ft-row">
        <div class="ft-col-33">
          <div class="ft-label">
            {{ 'flipto.account.sections.platform.photoAdvocacy.InvitationGreetingMessage' | translate }}
          </div>
        </div>
        <div class="ft-col-66" [innerHTML]="displayHtml(model().language?.inviteeGreeting, noneSetText)"></div>
      </div>
    </div>

    @if (isFliptoStaff()) {
      <div class="ft-panel" ft-modal-fields-editor (click)="editRequestPlaceInfo()">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label"
                 [innerHTML]="('flipto.account.sections.platform.photoAdvocacy.RequestPlaceInfoForPhoto' | translate)"></div>
          </div>
          <div class="ft-col-66">
            {{ data().contest?.isInviteeRequestPlaceForPhotoEnabled | onOff }}@if (data().contest?.isInviteeRequestPlaceForPhotoEnabled) {<span>, {{ data().contest?.isInviteeRequestPlaceForPhotoRequired ? 'required' : 'optional' }}</span>}
          </div>
        </div>
      </div>
    }

    @if (isFliptoStaff()) {
      <ft-select-editor title="Allowed places"
                        summary="Set which places should be available for your audience to select from. You can choose the 'Your places' option if you configure it in Mission Control."
                        [value]="data().contest?.allowedPlacesType"
                        (save)="onAllowedPlacesSave($event)"
                        [options]="model().allowedPlacesTypes"
                        [bindValue]="'value'"
                        [bindLabel]="'label'">
        <ft-edit-panel label="Allowed places">
          @for (option of selectedAllowedPlaces; track option) {
            <div class="ml-2">
              {{ option.label }}
            </div>
          }
        </ft-edit-panel>
      </ft-select-editor>
    }

    @if (isFliptoStaff()) {
      <div class="ft-panel" ft-modal-fields-editor (click)="editPlaceMessage()">
        <div class="ft-row">
          <div class="ft-col-33">
            <div class="ft-label">
              Place message
            </div>
          </div>
          <div class="ft-col-66" [innerHTML]="displayHtml(model().language?.inviteeQuotePlaceRequestMessage, 'Where was this photo taken?')"></div>
        </div>
      </div>
    }

    <!--REQUEST QUOTES SWITCH PANEL-->
    <div class="ft-panel" ft-modal-fields-editor (click)="editRequestQuotes()">
      <div class="ft-row">
        <div class="ft-col-33">
          <div class="ft-label"
               [innerHTML]="('flipto.account.sections.platform.photoAdvocacy.RequestQuotes' | translate)"></div>
        </div>
        <div class="ft-col-66">
          {{ data().contest?.isInviteeRequestQuotes | onOff }}
        </div>
      </div>
    </div>

    <!--INVITEE QUOTE REQUEST PANEL-->
    <div class="ft-panel" ft-modal-fields-editor (click)="editInviteeQuoteRequest()"
         [hidden]="!data().contest?.isInviteeRequestQuotes">
      <div class="ft-row">
        <div class="ft-col-33">
          <div class="ft-label">
            {{ 'flipto.account.sections.platform.photoAdvocacy.InvitationQuoteRequestMessage' | translate }}
          </div>
        </div>
        <div class="ft-col-66" [innerHTML]="displayHtml(model().language?.inviteeQuoteRequestMessage, noneSetText)"></div>
      </div>
    </div>

    <!--BACKGROUND IMAGE PANEL-->
    <div class="ft-panel last">
      <div class="ft-row" (click)="openInviteeImageLibrary()">
        <div class="ft-col-33">
          <div class="ft-label">{{ 'flipto.account.BackgroundImage' | translate }}</div>
        </div>
        <div class="ft-col-66">
          <div class="thumbnail-image"
               [ftBackgroundImage]="data().contest?.inviteeBackgroundImageUrl || model().defaultBackgroundImageUrl">
            <span class="placeholder"
                  [hidden]="(data().contest?.inviteeBackgroundImageUrl || model().defaultBackgroundImageUrl)">{{ 'flipto.account.AddAnImage' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ftModal phase 2: native field-editor modal shell (CDK overlay → stacks above the
     CDK contest sheet). Bool editors only so far; html/other types still bridged. -->
<ft-field-editor-modal [config]="fieldEditorConfig()" (closed)="fieldEditorConfig.set(null)" />

<!-- WS5 Phase 3 #7a: the invitee "Background image" modal, native (replaces the bridged
     $compile of <ft-modal id="contest-details.inviteeImageLibraryModal" header-text="Background image"
     on-done="save">). Its own CDK overlay stacks ABOVE the CDK contest sheet (the body-appended v1
     ftModal at z3000 was occluded behind the sheet at z999999 — un-gated, unnoticed; same class as
     the invitations bool/html editors). Done → save() (the full-union PUT); X/Cancel → close (the v1
     modal had no ft-snapshot → no revert). -->
<ft-modal-overlay [open]="inviteeImageModalOpen()">
  @if (inviteeImageModalOpen()) {
    <ft-modal-chrome-ng
      [headerText]="'flipto.account.BackgroundImage' | translate"
      size="sm"
      [doneVisible]="true"
      [cancelVisible]="true"
      [footerVisible]="true"
      [footerCancelVisible]="false"
      (done)="onInviteeImageDone()"
      (cancel)="inviteeImageModalOpen.set(false)"
    >
      <ft-image-library-ng [images]="data().propertyImages"
        [propertyId]="model().propertyId"
        [imageType]="3"
        view="list"
        (imageSelected)="updateInviteeImage($event)"
       />
    </ft-modal-chrome-ng>
  }
</ft-modal-overlay>
